export const PARTNERPLAN = {
  ALLOWEDEXTENSIONS: ['doc', 'docx', 'xls', 'xlsx', 'xlsm', 'pdf', 'ppt', 'pptx'],
  CSVHEADER: [
    { label: 'Partner Name', key: 'name' },
    { label: 'Plan Status', key: 'planStatus' },
    { label: 'Counselling Name', key: 'cpName' },
    { label: 'Market Leader Name', key: 'mlName' },
    { label: 'Business Leader Name', key: 'blName' },
    { label: 'Growth Leader Name', key: 'cilName' },
    { label: 'Plan Year', key: 'year' },
    { label: 'Interim Counsellee Assessment', key: 'interimCounsellee' },
    { label: 'Interim Counsellor Assessment', key: 'interimCounsellor' },
    { label: 'Final Counsellee Assessment', key: 'finalCounselleeAssessment' },
    { label: 'Final Counsellor Assessment', key: 'finalCounsellorAssessment' },
  ],
  CSVHEADERUPLOADLOG: [
    { label: 'Partner User Name', key: 'LoggedUser' },
    { label: 'Log', key: 'StackTrace' },
    { label: 'Time Stamp', key: 'TimeStamp' },
  ],
  CSVHEADERNOTIFICATION: [
    { label: 'Partner Emp Id', key: 'partnerEmpId' },
    { label: 'Partner Name', key: 'partnerName' },
    { label: 'Plan Status', key: 'planStatus' },
    { label: 'Plan Year', key: 'planYear' },
  ],
  DOCUMENTPREFIX:
  {
    INTERIM: 'Interim',
    FINAL: 'Final',
    PLAN: 'PartnerPlan',
  },
  DOCUMENTTYPE:
  {
    INITIALDOC: 'InitialDoc',
    PLAN: 'Plan',
    INTERIM: 'SupportingDocInterim',
    FINAL: 'SupportingDocFinal',
  },
  FILE_UPLOAD_DESC: 'Docs, Excel, Pdf and PPT only, max 20mb.',
  FILLER_EMPTY_HIERARCHY: 'undefined@deloitte.com.au',
  FORMS:
  {
    DRAFT: 'draftPlanForm',
    SUBMITTED: 'submittedPlanForm',
    INTERIM: 'interimPlanForm',
    INTERIM_COUNSELLOR: 'interimCounsellorPlanForm',
    FINAL: 'finalPlanForm',
    FINAL_COUNSELLOR: 'finalCounsellorPlanForm',
    NOTES: 'partnerPlanNoteForm',
    COMMENTS: 'partnerPlanCommentForm',
  },
  MAX_FILENAME_LENGHT: 30, // use to trim long filename
  MAX_FILESIZE: 20971520, // max file size upload in bytes
  NOTES_HEADER:
  {
    SUBMITTED: 'Plan agreed',
    INTERIM_PARTNER: 'Interim self assessment note',
    INTERIM_COUNSELLOR: 'Interim assessment note',
    FINAL_PARTNER: 'Final self assessment note',
    FINAL_COUNSELLOR: 'Final assessment note',
  },
  PLAN_FILTER_PARTNER_YEAR: '3', // limits the partner plan dataset return to only get from current year to previous years
  PLAN_FILTER_ADMIN_YEAR: '2019', // limits the partner plan dataset return to only get up to 2019
  RATINGS:
  {
    ON_TRACK_PLUS: 'On Track +',
    ON_TRACK: 'On Track',
    ON_TRACK_MINUS: 'On Track -',
    OFF_TRACK: 'Off Track',
    AHEAD_OF_TRACK: 'Ahead of Track',
    NOT_ELIGABLE: 'Not eligible',
  },
  ROLE:
  {
    MYPLANS: 'My plans',
    CP: 'Counselling partner',
    ML: 'Market leader',
    BL: 'Business leader',
    CIL: 'Growth leader',
    BUCOO: 'Business COO',
    OPL: 'Offering portfolio leader',
    OL: 'Offering leader',
    CEO: 'CEO',
  },
  ERROR_MESSAGE:
  {
    AGREED_WITH_COUNSELLEE: 'Please confirm that you have discussed and agreed this Partner Plan with your Counselee.',
  },
  PROGRESS_LABEL:
  {
    PARTNER_RATING_SUBMITTED: 'Partner rating submitted',
    COACH_AGREED: 'Discussed and agreed',
    COACH_RATING_AGREED: 'Coach rating discussed and agreed',
    FINAL_AGREED_INTERIM_RATING: 'Final interim rating',
    FINAL_AGREED_RATING: 'Final rating',
    AGREED_WITH_COUNSELLEE: 'I have discussed and agreed this Partner plan with my Counselee.',
    INTERIM_AGREED_WITH_COUNSELLEE: 'I have discussed and agreed this Interim assessment with my Counselee.',
    FINAL_AGREED_WITH_COUNSELLEE: 'I have discussed and agreed this Final assessment with my Counselee.',
  },
  STATUS:
  {
    DRAFT: 'Draft plan',
    UPLOADED: 'Uploaded',
    SUBMITTED: 'Submitted for review',
    AGREED: 'Plan agreed',
    INTERIM_ASSESSMENT: 'Interim assessment',
    INTERIM_ASSESSMENT_SUBMITTED: 'Interim assessment submitted',
    INTERIM_ASSESSMENT_AGREED: 'Interim assessment agreed',
    FINAL_ASSESSMENT: 'Final assessment',
    FINAL_ASSESSMENT_SUBMITTED: 'Final assessment submitted',
    FINAL_ASSESSMENT_AGREED: 'Final assessment agreed',
    EXEMPT: 'Exempt',
  },
  STEPS:
  {
    DRAFT: 'Draft plan',
    UPLOAD: 'Draft plan',
    SUBMIT: 'Partner plan submitted for review',
    AGREED: 'Partner plan agreed',
    INTERIM_ASSESSMENT: 'Interim assessment',
    INTERIM_ASSESSMENT_SUBMITTED: 'Interim assessment submitted for review',
    INTERIM_ASSESSMENT_AGREED: 'Interim assessment agreed',
    FINAL_ASSESSMENT: 'Final assessment',
    FINAL_ASSESSMENT_SUBMITTED: 'Final assessment submitted for review',
    FINAL_ASSESSMENT_AGREED: 'Final assessment agreed',
  },
  PHASE:
  {
    DRAFT: 'Draft plan',
    INTERIM_ASSESSMENT: 'Interim assessment',
    FINAL_ASSESSMENT: 'Final assessment',
  },
  VIEW:
  {
    MYPLANS: 'myplans',
    REVIEWPLANS: 'reviewplans',
  },
  RATINGSUPLOAD:
  {
    PENDING: 'Pending',
    COMPLETED: 'Completed',
    TEMPLATE: 'Template',
    COMPLETEDWITHERRORS: 'Completed with errors',
    COMPLETEDWITHWARNINGS: 'Completed with warnings',
    ERROR: 'Error',
    INVALIDUPLOAD: 'Invalid Upload',
  },
  RATINGSUPLOAD_FOLDER:
  {
    BUL: 'BUL',
    CP: 'CP',
    OL: 'OL',
  },
  RATINGSUPLOAD_INSTRUCTIONS: 'Ensure the CSV file includes correct plan ratings, year, and stage (interim or final) for each partner. Column titles are case-sensitive; ensure they match the template exactly.',
  RATINGSUPLOAD_INSTRUCTIONS_REVIEW: 'Always review the UPLOAD REPORT after each upload. Fix any reported issues and re-upload the file to ensure accuracy.',
  SPO_DATE_FORMAT: 'DD/MM/YYYY hh:mm a',
  MODIFIED_BY_ADMIN: 'Admin',
  REMINDER:
  {
    INTERIM: 'interim',
    FINAL: 'final',
  },
  FORMHEADER:
  {
    RATINGVISIBILITY: 'Partner plan final rating visibility',
  },
  SEARCHFILTER:
  {
    YEAR: 'Year',
    STAGE: 'Stage',
    STATUS: 'Status',
    TEXT: 'Text',
  },
  SEARCHFILTERSTATE:
  {
    STATUS: 'Status',
    YEAR: 'Year',
    TEXT: 'Text',
    CLEAR: 'Clear',
    INITIAL: 'Init',
  },
  SEARCHSESSIONKEY:
  {
    FILTER: 'PlanFilterSelection',
    STATE: 'PlanFilterSearchState',
  },
  RATINGSFORMHEADER:
  {
    COACH_INTERIM: 'Coach interim assessment',
    COACH_FINAL: 'Coach final assessment',
  },
}

export const PLANSTATUS = {
  ORDER: [
    { value: 1, label: PARTNERPLAN.STATUS.DRAFT },
    { value: 2, label: PARTNERPLAN.STATUS.UPLOADED },
    { value: 3, label: PARTNERPLAN.STATUS.SUBMITTED },
    { value: 4, label: PARTNERPLAN.STATUS.AGREED },
    { value: 5, label: PARTNERPLAN.STATUS.INTERIM_ASSESSMENT },
    { value: 6, label: PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_SUBMITTED },
    { value: 7, label: PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_AGREED },
    { value: 8, label: PARTNERPLAN.STATUS.FINAL_ASSESSMENT },
    { value: 9, label: PARTNERPLAN.STATUS.FINAL_ASSESSMENT_SUBMITTED },
    { value: 10, label: PARTNERPLAN.STATUS.FINAL_ASSESSMENT_AGREED },
    { value: 11, label: PARTNERPLAN.STATUS.EXEMPT },
  ],
}

export const PARTNERPLAN_LIST_OPTIONS = {
  RATINGS: [
    { value: PARTNERPLAN.RATINGS.AHEAD_OF_TRACK, label: PARTNERPLAN.RATINGS.AHEAD_OF_TRACK },
    { value: PARTNERPLAN.RATINGS.ON_TRACK_PLUS, label: PARTNERPLAN.RATINGS.ON_TRACK_PLUS },
    { value: PARTNERPLAN.RATINGS.ON_TRACK, label: PARTNERPLAN.RATINGS.ON_TRACK },
    { value: PARTNERPLAN.RATINGS.ON_TRACK_MINUS, label: PARTNERPLAN.RATINGS.ON_TRACK_MINUS },
    { value: PARTNERPLAN.RATINGS.OFF_TRACK, label: PARTNERPLAN.RATINGS.OFF_TRACK },
    { value: PARTNERPLAN.RATINGS.NOT_ELIGABLE, label: PARTNERPLAN.RATINGS.NOT_ELIGABLE },
  ],
  STATUS: [
    { value: PARTNERPLAN.STATUS.DRAFT, label: PARTNERPLAN.STATUS.DRAFT },
    { value: PARTNERPLAN.STATUS.UPLOADED, label: PARTNERPLAN.STATUS.UPLOADED },
    { value: PARTNERPLAN.STATUS.SUBMITTED, label: PARTNERPLAN.STATUS.SUBMITTED },
    { value: PARTNERPLAN.STATUS.AGREED, label: PARTNERPLAN.STATUS.AGREED },
    { value: PARTNERPLAN.STATUS.INTERIM_ASSESSMENT, label: PARTNERPLAN.STATUS.INTERIM_ASSESSMENT },
    { value: PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_SUBMITTED, label: PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_SUBMITTED },
    { value: PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_AGREED, label: PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_AGREED },
    { value: PARTNERPLAN.STATUS.FINAL_ASSESSMENT, label: PARTNERPLAN.STATUS.FINAL_ASSESSMENT },
    { value: PARTNERPLAN.STATUS.FINAL_ASSESSMENT_SUBMITTED, label: PARTNERPLAN.STATUS.FINAL_ASSESSMENT_SUBMITTED },
    { value: PARTNERPLAN.STATUS.FINAL_ASSESSMENT_AGREED, label: PARTNERPLAN.STATUS.FINAL_ASSESSMENT_AGREED },
    { value: PARTNERPLAN.STATUS.EXEMPT, label: PARTNERPLAN.STATUS.EXEMPT },
  ],
  EXEMPTIONS: [
    { value: 'Global/Asia Pac Role', label: 'Global/Asia Pac Role' },
    { value: 'New Lateral Hire', label: 'New Lateral Hire' },
    { value: 'New Partner Promote', label: 'New Partner Promote' },
    { value: 'Leave of absence LOA /extended medical leave', label: 'Leave of absence LOA /extended medical leave' },
    { value: 'Parental Leave', label: 'Parental Leave' },
    { value: 'Partner on Secondment', label: 'Partner on Secondment' },
    { value: 'Retiring Soon', label: 'Retiring Soon' },
    { value: 'Other', label: 'Other' },
  ],
  COUNSELLOR_PARTNER: [
    { value: 'Different Expectations', label: 'Different Expectations' },
    { value: 'External Factors', label: 'External Factors' },
    { value: 'Feedback Interpretation', label: 'Feedback Interpretation' },
    { value: 'Other', label: 'Other' },
  ],
  STAGE: [
    { value: 'interim', label: 'interim' },
    { value: 'final', label: 'final' },
  ],
}




// WEBPACK FOOTER //
// ./src/constants/partnerplan.js